import checkNameRequired from './checkNameRequired';
import showNameField from './showNameField';

const NameUtils = { checkNameRequired, showNameField };

export default NameUtils;
